<template>
  <div class="container">
    <div class="bread">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item class="bread1" :to="{ path: '/' }"
          >| 首页</el-breadcrumb-item
        >
        <el-breadcrumb-item class="bread1"
          ><span style="color: red; user-select: none"
            >招投标项目详情</span
          ></el-breadcrumb-item
        >
      </el-breadcrumb>
    </div>
    <!-- 项目图片轮播展示 -->
    <div style="position: relative">
      <!-- height: 500px; -->
      <div style="display: flex">
        <div class="particulars">
          <div class="slideshow">
            <el-carousel
              :interval="5000"
              arrow="always"
              height="380px"
              ref="carousel"
              v-if="projectDetail.imgList && projectDetail.imgList.length > 0"
            >
              <el-carousel-item
                v-for="(item, index) in projectDetail.imgList"
                :key="index"
              >
                <img
                  :src="item"
                  style="width: 100%; height: 380px; margin: 0 auto"
                />
              </el-carousel-item>
            </el-carousel>
            <img
              v-else
              src="../assets/img/zanwu.png"
              alt=""
              style="width: 100%; height: 380px; margin: 0 auto"
            />
          </div>
          <div class="lunbo-bottom">
            <div
              v-for="(item, index) in projectDetail.imgList"
              :key="index"
              class="lunbo-item"
              @click="qiehuanlunbo(index)"
            >
              <img :src="item" style="width: 100%; height: 100%" />
            </div>
          </div>
        </div>
        <!-- 右侧商品详细栏 -->
        <div class="left-xiangqing">
          <div class="top-title">
            <div style="color: #f56c6c; font-weight: 700">
              {{ projectDetail.deptName + projectDetail.projectName }}
            </div>
            <div class="sub-title">
              <span>项目编码： {{ projectDetail.numbering }} </span
              ><span
                >发布时间：
                {{ timeDetail.createTime ? timeDetail.createTime : "" }}
              </span>
            </div>
          </div>
          <!-- height: 450px -->
          <div style="display: flex">
            <div class="left-bottom" style="flex: 1">
              <div>
                预算金额：<span class="miaoshu">
                  {{ projectDetail.buggetAmount }}元
                </span>
              </div>
              <div>
                联系地址：<span class="miaoshu">
                  {{ projectDetail.address }}
                </span>
              </div>
              <div>
                招标方名称：<span class="miaoshu">
                  {{ projectDetail.company }}
                </span>
              </div>
              <div>
                企业性质：<span class="miaoshu"
                  >{{
                    getDictsVal(
                      dicts.business_natureList,
                      projectDetail.companyNature
                    )
                  }}
                </span>
              </div>
              <!-- <div>降价幅度：<span class="miaoshu" >
                                    {{ parseInt(projectDetail.floatingPrice) }} 元</span></div> -->
              <div v-if="projectDetail.status == 6">
                当前价格：<span class="miaoshu">{{ currentPrice }} 元</span>
              </div>
              <!-- <div
                    style="max-width: 300px;border: 1px solid #606266;padding: 2px 10px;height: 60;display: flex;align-items: center;border-radius: 4px;">
                    <input placeholder="请输入..." type="number"
                      style="outline: none;font-size: 20px;height: 100%;border: 0;margin-right: 4px;" v-model.trim="money"
                      readonly :step="projectDetail.floatingPrice" :min="minMonery">元
                    :οninput="money = (money || '').replace(/[^A-z0-9]/, '')"
                  </div> -->

              <div
                v-if="projectDetail.status == 6 && isApply == 1"
                style="display: flex; align-items: center; height: 50px"
              >
                出价：

                <el-input-number
                  v-model="money"
                  :step="Number(projectDetail.floatingPrice)"
                  step-strictly
                  class="input-number"
                  :min="
                    Number(currentPrice) + Number(projectDetail.floatingPrice)
                  "
                  @keydown.native="btKeyDown"
                  controls-position="right"
                ></el-input-number
                >元
                <!-- <div>
                                    <img src="@/assets/img/yijia.png"
                                        style="height: 30px;width: 30px;margin-left: 6px;">
                                    <span style="color: #ED222F;margin-left: 6px;">溢价率:{{ overRatio ? overRatio : '--'
                                        }}%</span>
                                </div> -->
              </div>
              <!-- v-if="projectDetail.status<=4" -->
              <!-- <div>浏览次数：<span class="miaoshu" >
                                    {{ projectDetail.watchCts ? projectDetail.watchCts : '0' }}
                                    次</span></div>
                            <div>报名人数：<span class="miaoshu" >
                                    {{ projectDetail.signCts ? projectDetail.signCts : '0' }}
                                    人</span></div> -->
              <div>
                报名时间：<span class="miaoshu">
                  {{ timeDetail.applyStartTime }} 至
                  {{ timeDetail.applyStopTime }}
                </span>
              </div>
              <!-- v-if="projectDetail.status==4" -->
              <!-- <div>
                竞价时间：<span class="miaoshu" >
                  {{ timeDetail.biddingStartTime }} 至
                  {{ timeDetail.biddingStopTime }}
                </span>
              </div> -->

              <div class="gobutton" v-if="projectDetail.status == 2">
                公示中
              </div>
              <div class="gobutton1" v-if="projectDetail.status == 3">
                公示结束
              </div>
              <!-- <div
                class="gobutton"
                @click="toChanquanbaoming"
                v-if="
                  
                  projectDetail.status == 4 &&
                  isApply == 0
                "
              >
                我要报名
              </div>
              <div
                class="gobutton"
                v-if="
                  
                  projectDetail.status == 4 &&
                  isApply == 1
                "
              >
                报名成功
              </div>
              <div
                class="gobutton"
                v-if="
                  
                  projectDetail.status == 4 &&
                  isApply == 2
                "
              >
                已报名待审核
              </div>
              <div
                class="gobutton1"
                v-if=" projectDetail.status == 5"
              >
                报名结束
              </div> -->
              <!-- <div class="gobutton1"
                                v-if=" projectDetail.status == 6 && isApply == 1" @click="bid">

                                我要出价
                            </div> -->
              <!-- <div class="gobutton1"
                                v-if=" projectDetail.status == 6 && isApply != 1">

                                未报名
                            </div> -->

              <div class="gobutton1" v-if="projectDetail.status >= 7">
                已结束
              </div>
            </div>
            <div
              style="
                flex: 1;
                padding: 0 16px;
                border-left: 1px solid #d9d9d9;
                margin: 16px 0;
                height: 400px;
              "
            >
              <div v-if="projectDetail.status < 4">
                距离报名开始：<span style="font-size: 28px; font-weight: 600"
                  >{{ nowDay }}天{{ nowHour }}时{{ nowMinute }}分{{
                    nowSecond
                  }}秒</span
                >
              </div>
              <div v-if="projectDetail.status == 4">
                距离报名截止仅剩<span style="font-size: 28px; font-weight: 600"
                  >{{ nowDay }}天{{ nowHour }}时{{ nowMinute }}分{{
                    nowSecond
                  }}秒</span
                >
              </div>
              <!-- <div v-if="projectDetail.status == 6">
                                距离竞价结束仅剩{{ nowDay }}天{{ nowHour }}时{{ nowMinute }}分{{ nowSecond }}秒
                            </div> -->
              <div style="display: flex; flex-direction: column; height: 100%">
                <div
                  style="
                    background-color: #f56c6c;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 10px 10px 0 0;
                  "
                >
                  <span
                    style="
                      color: #fff;
                      font-size: 30px;
                      font-family: Source Han Sans CN-Regular,
                        Source Han Sans CN;
                      padding: 8px 0;
                      font-weight: 400;
                      height: 54px;
                    "
                    ><span
                      v-if="
                        projectDetail.status >= 6 && projectDetail.status <= 11
                      "
                      >出价记录</span
                    ></span
                  >
                </div>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    max-height: 85%;
                    overflow: auto;
                    padding: 0 20px;
                  "
                >
                  <div
                    v-for="(data, index) in auctionRecords"
                    :key="index"
                    class="list"
                  >
                    <span style="flex: 1">{{ data.realname }}</span>
                    <span style="flex: 2">{{ data.createTime }}</span>
                    <span style="flex: 1; text-align: right"
                      >{{ data.money }}元</span
                    >
                  </div>
                </div>
              </div>
              <div style="font-size: 20px; color: red">
                <i class="el-icon-warning"></i
                >重要提示:报价过程数据仅体现标的价格，不包含服务费!
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部商品详细及交易须知 -->
    <div style="margin-top: 60px">
      <div
        style="
          display: flex;
          font-size: 28px;
          height: 70px;
          line-height: 70px;
          border-bottom: 1px solid black;
          background-color: #f7f7f7;
        "
      >
        <div
          @click="getDetailActive = 1"
          :class="getDetailActive == 1 ? 'getDetail' : 'getdetail'"
        >
          <a href="#xmxx" :class="getDetailActive == 1 ? 'gettimeDetail' : ''"
            >招标方信息</a
          >
        </div>
        <div
          @click="getDetailActive = 2"
          :class="getDetailActive == 2 ? 'getDetail' : 'getdetail'"
        >
          <a href="#jysj" :class="getDetailActive == 2 ? 'gettimeDetail' : ''"
            >招标项目信息</a
          >
        </div>
        <div
          @click="getDetailActive = 3"
          :class="getDetailActive == 3 ? 'getDetail' : 'getdetail'"
        >
          <a href="#tpzs" :class="getDetailActive == 3 ? 'gettimeDetail' : ''"
            >图片展示</a
          >
        </div>
        <div
          @click="getDetailActive = 4"
          :class="getDetailActive == 4 ? 'getDetail' : 'getdetail'"
        >
          <a href="#bmxz" :class="getDetailActive == 4 ? 'gettimeDetail' : ''"
            >报名须知</a
          >
        </div>
        <div
          v-if="cityDetail.showZTBCjgg"
          @click="getDetailActive = 5"
          :class="getDetailActive == 5 ? 'getDetail' : 'getdetail'"
        >
          <a
            href="#zbcjjggg"
            :class="getDetailActive == 5 ? 'gettimeDetail' : ''"
            >中标(成交)结果公告</a
          >
        </div>
      </div>
      <div
        style="
          text-align: center;
          padding: 20px;
          padding-top: 40px;
          font-size: 24px;
        "
      >
        <!-- <el-divider content-position="center">项目详情</el-divider>style="opacity:0" -->
        <div>
          <div class="footerTitle" id="xmxx"></div>
          <div>
            <div class="fengexian">
              <el-divider content-position="center">招标方信息</el-divider>
            </div>
          </div>
          <div style="display: flex">
            <div class="left" style="width: 100%; text-align: left">
              <div class="tet">
                <div class="tet1">招标方名称:</div>
                <div class="tet2">
                  <span>{{ projectDetail.company || "/" }}</span>
                </div>
              </div>
              <div class="tet">
                <!-- 公司性质 business_nature:报名竞拍时候的公司性质 -->
                <div class="tet1">企业性质:</div>
                <div class="tet2">
                  <span>{{
                    getDictsVal(
                      dicts.business_natureList,
                      projectDetail.companyNature
                    ) || "/"
                  }}</span>
                </div>
              </div>
              <div class="tet">
                <div class="tet1">招标人电话:</div>
                <div class="tet2">
                  <span>{{ realPhone || projectDetail.phone || "/" }}</span>
                  <img
                    v-if="projectDetail.phone"
                    src="../assets/img/openEye.png"
                    style="width: 30px; height: 30px; cursor: pointer"
                    @click="checkShowPhone"
                  />
                </div>
              </div>
              <div class="tet">
                <div class="tet1">财政资金:</div>
                <div class="tet2">
                  <span
                    >{{
                      projectDetail.amount1 ? projectDetail.amount1 : 0
                    }}
                    元</span
                  >
                </div>
              </div>
              <!-- 
              <div class="tet">
                <div class="tet1">科委:</div>
                <div class="tet2" >
                  <span>{{ projectDetail.amount3 ? projectDetail.amount3 : 0 }} 元</span>
                </div>
              </div>
              <div class="tet">
                <div class="tet1">自筹:</div>
                <div class="tet2" >
                  <span>{{ projectDetail.amount5 ? projectDetail.amount5 : 0 }} 元</span>
                </div>
              </div> -->
              <div class="tet">
                <div class="tet1">总金额:</div>
                <div class="tet2">
                  <span
                    >{{
                      projectDetail.amount ? projectDetail.amount + "元" : "/"
                    }}
                  </span>
                </div>
              </div>

              <div class="tet">
                <div class="tet1">地址:</div>
                <div class="tet2">
                  <span>{{ projectDetail.address || "/" }}</span>
                </div>
              </div>
              <div class="tet">
                <div class="tet1">法定代表人/负责人:</div>
                <div class="tet2">
                  <span>{{ projectDetail.linkman || "/" }}</span>
                </div>
              </div>
              <div class="tet">
                <div class="tet1">项目类型:</div>
                <div class="tet2">
                  <span>{{
                    getType(typeList, projectDetail.type) || "/"
                  }}</span>
                </div>
              </div>
              <!-- <div class="tet">
                <div class="tet1">农委:</div>
                <div class="tet2" >
                  <span>{{ projectDetail.amount2 ? projectDetail.amount2 : 0 }} 元</span>
                </div>
              </div>
              <div class="tet">
                <div class="tet1">发改委:</div>
                <div class="tet2" >
                  <span>{{ projectDetail.amount4 ? projectDetail.amount4 : 0 }} 元</span>
                </div>
              </div>
              <div class="tet">
                <div class="tet1">其他:</div>
                <div class="tet2" >
                  <span>{{ projectDetail.amount6 ? projectDetail.amount6 : 0 }} 元</span>
                </div>
              </div> -->
            </div>
          </div>
        </div>

        <div style="border: 1px solid #fff">
          <div class="footerTitle" id="jysj"></div>
          <div>
            <div class="fengexian1">
              <el-divider content-position="center">招标项目信息</el-divider>
            </div>
          </div>
          <!-- <div style="margin-top: 40px;" class="footerTitle" id="jysj">交易条件</div> -->
          <div style="display: flex">
            <div class="left" style="width: 100%; text-align: left">
              <div class="tet">
                <div class="tet1">项目名称:</div>
                <div class="tet2">
                  <span>{{
                    (cityDetail.cityName == "辉县市"
                      ? projectDetail.address + projectDetail.projectName
                      : projectDetail.projectName) || "/"
                  }}</span>
                </div>
              </div>
              <!-- <div class="tet">
                <div class="tet1">是否为农用项目:</div>
                <div class="tet3">
                  <span>{{
                    getDictsVal(
                      dicts.isAgricultureList,
                      projectDetail.isAgriculture
                    ) || "/"
                  }}</span>
                </div>
              </div> -->
              <div class="tet">
                <div class="tet1">预算金额:</div>
                <div class="tet3">
                  <span
                    >{{
                      projectDetail.buggetAmount
                        ? projectDetail.buggetAmount + "元"
                        : "/"
                    }}
                  </span>
                </div>
              </div>
              <!-- <div class="tet">
                <div class="tet1">是否交纳投标保证金:</div>
                <div class="tet3">
                  <span>{{
                    getDictsVal(dicts.isBailList, projectDetail.isBail) || "/"
                  }}</span>
                </div>
              </div> -->
              <div class="tet">
                <div class="tet1">工程价款支付方式:</div>
                <div class="tet3">
                  <span>{{
                    getDictsVal(dicts.payTypeList, projectDetail.payType) || "/"
                  }}</span>
                </div>
              </div>
              <div class="tet">
                <div class="tet1">保证金交纳形式:</div>
                <div class="tet3">
                  <span>{{
                    getDictsVal(dicts.payTypeList, projectDetail.bailPayType) ||
                    "/"
                  }}</span>
                </div>
              </div>
              <div class="tet">
                <div class="tet1">代理公司联系人:</div>
                <div class="tet3">
                  <span>{{ projectDetail.linkMan || "/" }}</span>
                </div>
              </div>
              <div class="tet">
                <div class="tet1">代理公司联系地址:</div>
                <div class="tet3">
                  <span>{{ projectDetail.linkAddress || "/" }}</span>
                </div>
              </div>
              <!-- <div class="tet">
                <div class="tet1">招标人意见 :</div>
                <div class="tet3">
                  <span>{{ projectDetail.tenderOpinion || "/" }}</span>
                </div>
              </div> -->
              <div class="tet">
                <div class="tet1">信息技术服务费（文书费）:</div>
                <div class="tet3">
                  <span>{{
                    projectDetail.bookPrice
                      ? projectDetail.bookPrice + "元"
                      : "/"
                  }}</span>
                </div>
              </div>

              <!-- <div class="tet">
                <div class="tet1">项目规模:</div>
                <div class="tet2">
                  <span>{{ projectDetail.scale || "/" }}</span>
                </div>
              </div> -->
              <!-- <div class="tet">
                <div class="tet1">农户数量:</div>
                <div class="tet2">
                  <span>{{
                    projectDetail.farmers ? projectDetail.farmers + "人" : "/"
                  }}</span>
                </div>
              </div> -->
              <div class="tet">
                <div class="tet1">项目周期:</div>
                <div class="tet3">
                  <span>{{
                    projectDetail.timelimit
                      ? projectDetail.timelimit + "日历天"
                      : "/"
                  }}</span>
                </div>
              </div>
              <div class="tet">
                <div class="tet1">交易保证金(元):</div>
                <div class="tet3">
                  <span
                    >{{
                      projectDetail.bailAmount
                        ? projectDetail.bailAmount + "元"
                        : "/"
                    }}
                  </span>
                </div>
              </div>
              <!-- <div class="tet">
                <div class="tet1">竞价方向:</div>
                <div class="tet3">
                  <span >{{
                    getDictsVal(
                      dicts.bidding_directionList,
                      projectDetail.biddingDirection
                    )
                  }}</span>
                </div>
              </div> -->
              <div class="tet">
                <div class="tet1">投标方条件:</div>
                <div class="tet3">
                  <span>{{ projectDetail.qualifications || "/" }}</span>
                </div>
              </div>
              <div class="tet">
                <div class="tet1">其他描述:</div>
                <div class="tet3">
                  <span>{{ projectDetail.description || "/" }}</span>
                </div>
              </div>
              <div class="tet">
                <div class="tet1">招标代理公司名称:</div>
                <div class="tet3">
                  <span>{{ projectDetail.agentName || "/" }}</span>
                </div>
              </div>
              <div class="tet">
                <div class="tet1">代理公司联系电话:</div>
                <div class="tet3">
                  <span>{{ projectDetail.linkPhone || "/" }}</span>
                </div>
              </div>
              <!-- <div class="tet">
                <div class="tet1">代理公司意见:</div>
                <div class="tet3">
                  <span>{{ projectDetail.agentopinion || "/" }}</span>
                </div>
              </div> -->
              <div class="tet">
                <div class="tet1">招标文件领取时间 :</div>
                <div class="tet3">
                  <span
                    >{{ projectDetail.getStartTime }}-{{
                      projectDetail.getStopTime
                    }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <!-- <div style="margin-top: 40px;" class="footerTitle" id="tpzs">图片展示</div> -->
          <div class="footerTitle" id="tpzs"></div>
          <div>
            <div class="fengexian1">
              <el-divider content-position="center">图片展示</el-divider>
            </div>
          </div>
          <div class="imgcontent">
            <el-image
              v-for="(item, index) in projectDetail.imgList"
              :key="index"
              style="
                width: 48%;
                height: auto;
                margin-left: 10px;
                margin-bottom: 10px;
              "
              :src="item"
              :preview-src-list="projectDetail.imgList"
            >
            </el-image>
          </div>
        </div>
        <div>
          <div class="footerTitle" id="bmxz"></div>
          <div>
            <div class="fengexian1">
              <el-divider content-position="center">报名须知</el-divider>
            </div>
          </div>
          <div
            style="
              text-align: left;
              line-height: 40px;
              font-size: 20px;
              margin-bottom: 40px;
              background-color: rgb(240, 248, 246);
              padding: 10px;
              box-sizing: border-box;
            "
          >
            <p>一、报名人持下列材料到本县农村产权交易服务中心报名：</p>
            <p>1、有效资格证件：</p>
            <p>
              （1）意向受让方为自然人，需提供本人身份证复印件或常住人口户口簿复印件；
            </p>
            <p>
              （2） 意向受让方为公司，需提供
              法定代表人身份证复印件、已年检的营业执照、开户行资信证明、开户行许可证、已年检组织机构代码证、已年检税务登记证、开发项目的可行性报告书、公司章程以及董事会或股东（大）会同意受让决议；
            </p>
            <p>
              （3）
              意向受让方为合作社，需提供法定代表人身份证复印件、已年检的营业执照、开户行资信证明、开户行许可证、已年检组织机构代码证、已年检税务登记证、开发项目的可行性报告书、合作社成员同意受让决议。
            </p>
            <p>2、若为授权人提出申请，需提供授权委托书及身份证复印件。</p>
            <p>
              二、挂牌期满，若征集到符合条件的意向受让方，采取协议或者竞标方式确定受让方。
            </p>
            <p>三、法定节假日、公休日不受理报名。</p>
            <!-- <p style="color: #F96226;">
  
              </p> -->
          </div>
        </div>
        <div>
          <!-- <div class="footerTitle" id="bmxz"></div> -->
          <div>
            <div class="fengexian1">
              <el-divider content-position="center">竞买登记</el-divider>
            </div>
          </div>

          <table style="width: 100%" border="1">
            <tr>
              <th>投标方资格条件</th>
              <td></td>
            </tr>
            <tr>
              <th>报名方式</th>
              <td>
                <p>1、意向受让方首次报名须知：</p>
                <p>
                  ①企业法人单位组织须提交加盖公章的《营业执照》复印件等证明主体资格的相关材料以及法定代表人身份证复印件、经办人身份证复印件、授权委托书、公章、法人章等相关材料；
                </p>
                <p>
                  ②非企业法人单位须提交以下资料：申请人身份证正反面复印件1份、申请人银行卡正反面复印件1份。
                </p>
                <p>
                  2、非首次报名的意向受让方按时根据保证金备注要求交纳交易保证金后即可参与本期竞价。
                </p>
                <p>
                  3、交易中心向意向受让方发放报价账号（长期有效、注意保管）。
                </p>
                <p>
                  4、交易保证金交纳截止日当天17:30前未收到交易账号激活短信的意向受让方，请致电交易中心。
                </p>
              </td>
            </tr>
            <tr>
              <th>保证金及处理方式</th>
              <td>
                <p style="font-weight: bold">
                  1、须交纳的交易保证金金额为人民币{{
                    projectDetail.bailAmount
                  }}元。
                </p>
                <p style="font-weight: bold">
                  2、开户行:{{
                    backCardInfo
                      ? backCardInfo.bankName
                      : "中国建设银行股份有限公司信阳北京路支行"
                  }}
                </p>
                <p style="font-weight: bold">
                  户名:{{
                    backCardInfo
                      ? backCardInfo.cardName
                      : "信阳市申资产权交易有限责任公司"
                  }}
                </p>
                <p style="font-weight: bold">
                  账号:{{
                    backCardInfo ? backCardInfo.cardNo : "41001551417050201184"
                  }}
                </p>
                <p>
                  须在交纳保证金截止时间前电话通知交易中心已交纳保证金，如未通知或不得参与竞价。
                </p>
                <p>交纳交易保证金要求：</p>
                <p>
                  ①交易保证金可选择网上银行转账、手机银行转账、银行柜面转账、线上支付方式提交。
                </p>
                <p>② 交纳交易保证金时，须备注相关信息：</p>
                <p>企业：项目名称+企业名称。例：XX项目XX公司保证金；</p>
                <p>个人：项目名称+姓名。例：XX项目XX保证金；</p>
                <p>
                  交易保证金交易截止时间前未正确备注信息的，资格审查不予通过。
                </p>
                <p>
                  未成交者的交易保证金交易中心将在交易结束后15个工作日内全额无息返还。
                </p>
                <p>
                  ③竞拍人竞买成功后，携带相关资料到交易中心缴纳服务费，在交易中心主持下与出让方签订合同。
                </p>
                <p>
                  ④成交人交易保证金作为出让金转入出让方账户，溢价部分向出让方补缴齐。
                </p>
              </td>
            </tr>
          </table>
        </div>
        <div v-if="cityDetail.showZTBCjgg">
          <div class="footerTitle" id="zbcjjggg"></div>
          <div>
            <div class="fengexian1">
              <el-divider content-position="center"
                >中标(成交)结果公告</el-divider
              >
            </div>
            <div class="hetongBox">
              <p style="text-align: center; font-size: 30px; font-weight: 700">
                辉县市黄水乡韩口村水仙寺恢复水泉眼项目中标（成交）结果公告
              </p>
              <br />
              <p style="text-indent: 2em">
                参照《中华人民共和国政府采购法》等有关法律、法规和该项目竞争性磋商文件的规定，{{
                  projectDetail.address + projectDetail.projectName
                }}项目经依法组建的磋商小组评审，根据磋商小组提交的评标报告，现将结果情况公示如下：
              </p>
              <p style="text-indent: 2em">一、项目名称及编号：</p>
              <p style="text-indent: 2em">
                项目名称：{{
                  projectDetail.address + projectDetail.projectName
                }}
              </p>
              <p style="text-indent: 2em">
                项目编号：{{ projectDetail.numbering }}
              </p>
              <p style="text-indent: 2em">二、项目情况</p>
              <p style="text-indent: 2em">
                1、项目地点：{{ projectDetail.address }}
              </p>
              <p style="text-indent: 2em">2、采购方式：竞争性磋商</p>
              <p style="text-indent: 2em">3、磋商资金来源：自筹资金</p>
              <p style="text-indent: 2em">
                4、磋商范围：工程量清单范围内的所有内容。
              </p>
              <p style="text-indent: 2em">5、质量要求：合格</p>
              <p style="text-indent: 2em">
                6、工期：{{
                  projectDetail.timelimit
                    ? projectDetail.timelimit + "日历天"
                    : "/"
                }}
              </p>
              <p style="text-indent: 2em">三、公告发布日期：</p>
              <p style="text-indent: 2em">本项目竞争性磋商公告发布日期：</p>
              <p style="text-indent: 2em">四、评标信息：</p>
              <p style="text-indent: 2em">评标日期：</p>
              <p style="text-indent: 2em">磋商小组成员：</p>
              <p style="text-indent: 2em">五、评审结果：</p>
              <p style="text-indent: 2em">成交供应商：</p>
              <p style="text-indent: 2em">最终报价：</p>
              <p style="text-indent: 2em">法定代表人：</p>
              <p style="text-indent: 2em">联系地址：</p>
              <p style="text-indent: 2em">六、公布媒介及公示期限：</p>
              <p style="text-indent: 2em">
                本次结果公告在《辉县市农村产权交易信息服务平台》、《中国采购与招标网》上发布，公告期限为1个工作日。
              </p>
              <p style="text-indent: 2em">七、项目联系事项</p>
              <p style="text-indent: 2em">采 购 人：</p>
              <p style="text-indent: 2em">联 系 人： 联系电话：</p>
              <p style="text-indent: 2em">采购代理机构：</p>
              <p style="text-indent: 2em">联 系 人： 联系电话：</p>
              <p style="text-indent: 2em; text-align: right">xxxxxxx</p>
              <p style="text-indent: 2em; text-align: right">2025年8月13日</p>
            </div>
          </div>
        </div>

        <!-- <div>
          <div class="footerTitle" id="bmxz"></div>
          <div>
            <div class="fengexian1">
              <el-divider content-position="center">交易方式</el-divider>
            </div>
          </div>

          <table style="width: 100%" border="1">
            <tr>
              <th>成交确认、价款支付及合同签订</th>
              <td>
                <p>
                  1、成交后，受让方应在两个工作日内到交易中心或转让方处领取《成交通知书》。标的成交的，受让方未在规定的时间内到交易中心或转让方处领取《成交通知书》的，交易中心将视作受让方知晓及认可相关交易内容，认可已成交标的相关权利和义务，如由此引发的一切法律纠纷由受让方自行承担，交易中心有权追究其相关法律责任。
                </p>
                <p>
                  2、受让方须在成交之次日起5个工作日内持《成交通知书》和付款凭证与招标方签订《招标合同》，约定双方相关的责任和义务；
                </p>
                <p>
                  3、受让方不根据本公告要求履约的，视为自动放弃受让资格，其已交纳的交易保证金不予退回，并对交易中心因此造成的损失承担赔偿责任，招标方有权将该标重新组织竞买交易。
                </p>
              </td>
            </tr>
            <tr>
              <th>投标方资格条件</th>
              <td>双方按相关合同约定进行交割。</td>
            </tr>
          </table>
        </div>

        <div>
          <div class="footerTitle" id="bmxz"></div>
          <div>
            <div class="fengexian1">
              <el-divider content-position="center">其他事项</el-divider>
            </div>
          </div>

          <div style="
              text-align: left;
              line-height: 40px;
              font-size: 20px;
              margin-bottom: 40px;
              background-color: rgb(240, 248, 246);
              padding: 10px;
              box-sizing: border-box;
            ">
            <p>
              1、意向受让方参与交易前应仔细阅读本信息公告、“附件”中所有材料、阅读了解{{
                deptName
              }}农村综合产权交易中心相关交易规则等有关材料，一旦参与交易（报名）则视为意向受让方已充分了解并接受信息公告（含附件材料）、{{
                deptName
              }}农村综合产权交易中心交易规则等全部内容，愿意承担可能存在的一切交易风险。
            </p>
            <p>
              2、{{
                deptName ? deptName : ""
              }}农村综合产权交易中心相关交易规则请查看{{
                deptName ? deptName : ""
              }}农村综合产权交易中心官网：交易指南 — 交易规则
            </p>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { getInvitationDetail } from '@/api/招投标'
import { checkToken, getPhoneById } from '../api/login'
import {
  getTypeList,
  isApply,
  getBankCardInfo,
  watchProject,
  getInfoByDeptId,
} from '../api/交易项目详情'
import { getProList } from '../api/交易项目'
import { cityDetail } from '../util/mainOption'
export default {
  data () {
    return {
      // 查看区域下标
      getDetailActive: '1',
      // 当前地级名称
      deptName: '',
      // 项目详情
      projectDetail: {},
      // 请求是否有数据
      // 时间详情
      timeDetail: {},
      // 出价记录
      auctionRecords: [],
      // 交纳保证金账户信息
      backCardInfo: {},
      // 当前价格
      currentPrice: -999,
      // 计时器
      timer: null,
      // 当前天数
      nowDay: 0,
      // 当前小时
      nowHour: 0,
      // 当前分钟
      nowMinute: 0,
      // 当前秒数
      nowSecond: 0,
      // 账户报名状态
      isApply: 0, //0未报名,1已报名2已报名未审核
      // 价格计时器
      priceTimer: null,
      // token验证是否通过
      chechTokenRes: false,
      dicts: {
        // 公司性质
        business_natureList: [],
        // 是否交纳投标保证金
        isBailList: [],
        // 是否为农用项目
        isAgricultureList: [],
        // 工程价款支付方式
        payTypeList: [],
        // 竞价方向
        bidding_directionList: [],
      },
      // 项目类型
      typeList: [],
      accomplish: false,
      realPhone: "",
    }
  },
  mounted () {
    if (this.$route.query.id) {
      getInvitationDetail(this.$route.query).then((res) => {
        if (!res.data.data) {
          this.$message.error('无该项目信息')
          return
        }
        this.projectDetail = res.data.data
        getInfoByDeptId(this.projectDetail.deptId).then((res) => {
          console.log('res', res)
          this.backCardInfo = res.data.data
        })
        this.timeDetail = this.projectDetail.releaseRecord
        this.projectDetail.imgList = res.data.data.imgs.split(',')
        watchProject({ dataId: this.projectDetail.id, type: 1 })
        getProList({ type: 1 }).then((res) => {
          console.log(res.data.data)
          this.typeList = res.data.data
        })
        getTypeList('bidding_direction').then((res) => {
          this.dicts.bidding_directionList = res.data.data
        })
        getTypeList('business_nature').then((res) => {
          this.dicts.business_natureList = res.data.data
        })
        getTypeList('isAgriculture').then((res) => {
          this.dicts.isAgricultureList = res.data.data
        })
        getTypeList('guarantee_money').then((res) => {
          this.dicts.isBailList = res.data.data
        })
        getTypeList('payType').then((res) => {
          this.dicts.payTypeList = res.data.data
        })
        this.deptName = localStorage.getItem('deptName')
          ? localStorage.getItem('deptName')
          : this.cityDetail.cityName
        if (localStorage.getItem('token')) {
          checkToken().then((res) => {
            if (res.data.code == 200) {
              this.chechTokenRes = true
              isApply({
                projectId: this.projectDetail.id,
                projectType: 1,
              }).then((res) => {
                this.isApply = res.data.data
              })
            } else {
              this.$message.error('暂未登录')
            }
          })
        } else {
          this.$message.error('暂未登录')
        }
        this.rebootCountDown()
        this.getProjectDetail()
      })
    }
  },
  methods: {
    // 手机号小眼睛点击事件
    checkShowPhone () {
      if (this.realPhone) return
      if (!localStorage.getItem('token')) {
        this.$message.warning("请登录后查看！")
        return
      }
      getPhoneById({
        id: this.$route.query.id,
        projectType: 1
      }).then(res => {
        if (res.data.code == 200) {
          this.realPhone = res.data.msg
        }
      })
    },
    // 获取项目类型方法
    getType (list, code) {
      console.log(list)
      if (!list && !code) {
        return ''
      }
      return list.filter((item) => {
        return item.code == code
      })[0]
        ? list.filter((item) => {
          return item.code == code
        })[0].name
        : ''
    },
    // 获取字典内容方法
    getDictsVal (list, val) {
      if (!!list && !!val) {
        return list.filter((item) => {
          return item.dictValue == val
        })[0]
          ? list.filter((item) => {
            return item.dictValue == val
          })[0].dictLabel
          : ''
      }
      return ''
    },
    // 重启计时器方法
    rebootCountDown () {
      this.timer = setInterval(() => {
        let time
        if (this.projectDetail.status < 4) {
          time = this.countDown(this.timeDetail.applyStartTime)
        } else if (this.projectDetail.status == 4) {
          time = this.countDown(this.timeDetail.applyStopTime)
        } else if (this.projectDetail.status == 6) {
          time = this.countDown(this.timeDetail.biddingStopTime)
        } else {
          clearInterval(this.timer)
          return
        }
        this.nowDay = time.day ? time.day : 0
        this.nowHour = time.hour ? time.hour : 0
        this.nowMinute = time.minute ? time.minute : 0
        this.nowSecond = time.second ? time.second : 0
        if (!time.day && !time.hour && !time.minute && !time.second) {
          clearInterval(this.timer)
          if (this.accomplish) {
            return
          }
          this.accomplish = true
          setTimeout(() => {
            this.getProjectDetail()
            this.accomplish = false
          }, 5000)
          return
        }
      }, 1000)
    },
    // 倒计时方法
    countDown (endTime) {
      let now = new Date().getTime()
      let end = new Date(endTime).getTime()
      let time = {
        day: 0,
        hour: 0,
        minute: 0,
        second: 0,
      }
      if (now >= end) {
        return time
      }
      time.day = Math.floor((Number(end) - Number(now)) / (1000 * 60 * 60 * 24))
      time.hour = Math.floor(
        (Number(end) - Number(now) - time.day * 1000 * 60 * 60 * 24) /
        (1000 * 60 * 60)
      )
      time.minute = Math.floor(
        (Number(end) -
          Number(now) -
          (time.day * 1000 * 60 * 60 * 24 + time.hour * 1000 * 60 * 60)) /
        (1000 * 60)
      )
      time.second = Math.floor(
        (Number(end) -
          Number(now) -
          (time.day * 1000 * 60 * 60 * 24 +
            time.hour * 1000 * 60 * 60 +
            time.minute * 1000 * 60)) /
        1000
      )
      return time
    },
    // 报名按钮事件
    toChanquanbaoming () {
      if (localStorage.getItem('token') && this.chechTokenRes) {
        this.$router.push({
          name: '产权报名',
          query: { id: this.projectDetail.id, type: 1 },
        })
      } else {
        this.$message.error('请先登录')
        if (cityDetail.homeShowLogin) {
          this.$router.push('/')
        } else {
          this.$router.push('/login')
        }
      }
    },
    // 获取项目详情
    getProjectDetail () {
      if (this.$route.query.id) {
        getInvitationDetail(this.$route.query).then((res) => {
          if (!res.data.data) {
            this.$message.error('无该项目信息')
            return
          }
          this.projectDetail = res.data.data
          getInfoByDeptId(this.projectDetail.deptId).then((res) => {
            console.log('res', res)
            this.backCardInfo = res.data.data
          })
          this.rebootCountDown()
        })
      }
    },
    // 限制加价框输入
    btKeyDown (e) {
      e.target.value = e.target.value.replace(
        /[^\a-\z\A-\Z0-9\u4E00-\u9FA5]/g,
        ''
      )
    },
  },
}
</script>

<style scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

.imgcontent {
  display: flex;
  /* justify-content: s; */
  flex-wrap: wrap;
}

.lunbo-bottom {
  display: flex;
  /* border: 1px solid red; */
  margin-top: 7px;
  height: 110px;
}

.lunbo-item {
  width: 25%;
  margin-right: 5px;
  cursor: pointer;
}

.lunbo-item:last-child {
  margin-right: 0;
}

.top-title {
  height: 85px;
  border-bottom: #d1d1d2 1px solid;
  padding-left: 30px;
}

.left-bottom {
  font-size: 20px;
  padding: 30px;
  color: #666;
}

.left-bottom > div {
  line-height: 45px;
  height: 45px;
}

.gobutton {
  width: 200px;
  text-align: center;
  margin: 0 auto;
  background-color: #67c23a;
  border-radius: 10px;
  font-size: 25px;
  color: #fff;
  cursor: pointer;
  user-select: none;
}

.gobutton1 {
  width: 200px;
  text-align: center;
  margin: 0 auto;
  background-color: #f56c6c;
  border-radius: 10px;
  font-size: 25px;
  color: #fff;
  cursor: pointer;
  user-select: none;
  margin-top: 20px;
}

.miaoshu {
  color: #333;
}

.sub-title {
  color: #999;
  font-size: 18px;
  margin-top: 15px;
}

.sub-title span {
  margin-right: 50px;
}

.left-xiangqing {
  border: 1px solid #d1d1d2;
  flex: 1;
  margin-left: 30px;
  font-size: 26px;
  padding: 15px 0;
  color: #333;
}

* {
  padding: 0;
  margin: 0;
}

a {
  text-decoration: none;
  color: black;
}

.container {
  margin: 0 auto;
  width: 1860px;
  background-color: #fff;
  padding: 20px;
}

.bread {
  margin: 20px 0;
}

.bread1 {
  font-size: 18px;
}

.particulars {
  width: 30%;
  height: 100%;
}

.slideshow {
  width: 100%;
  /* height: 400px; */
  /* margin-top: 3%; */
  /* margin: /auto 0; */
}

.footer {
  display: flex;
  font-size: 22px;
}

.footerDiv {
  margin: 8px 0;
  font-weight: 600;
}

.footerTitle {
  font-size: 36px;
  height: 15px;
  /* border: #67C23A 1px solid; */
  /* margin-bottom: 40px; */
  color: #f56c6c;
  /* list-style: armenian; */
}

.fengexian {
  margin-bottom: 40px;
}

.fengexian >>> .el-divider__text {
  font-size: 36px;
  /* margin-bottom: 40px; */
  color: #f56c6c;
  list-style: armenian;
}

.fengexian1 {
  margin: 30px 0 50px 0;
}

.fengexian1 >>> .el-divider__text {
  font-size: 36px;
  /* margin-bottom: 40px; */
  color: #f56c6c;
  list-style: armenian;
}

.applyDetail {
  width: 85%;
  height: 55%;
  border: 1px solid #d1d1d2;
}

.left > div {
  border: 1px solid rgb(210, 210, 210);
  /* padding: 30px; */
  margin: 0 !important;
  display: flex;
  width: 50%;
}

.left {
  width: 100%;
  text-align: left;
  display: flex;
  max-width: 100%;
  flex-wrap: wrap;
}
.getdetail {
  font-size: 24px;
  padding: 0 30px;
  font-weight: 600;
  opacity: 0.5;
}

.getDetail {
  font-size: 24px;
  padding: 0 30px;
  border-top: 1px solid #f56c6c;
  background-color: white;
}

.gettimeDetail {
  color: #f56c6c;
  font-weight: 600;
}

.tet {
  border: 1px solid rgb(210, 210, 210);
  /* padding: 30px; */
  margin: 0 !important;
  display: flex;
}

.tet1 {
  width: 350px;
  border-right: 1px solid #f3f5f8;
  padding: 20px 20px;
  text-align: center;
  font-weight: 600;
  background-color: #f3f5f8;
}

.tet2 {
  padding: 20px 20px;
  width: 550px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tet3 {
  padding: 20px 20px;
  width: 550px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.money {
  display: flex;
  flex-direction: column;
}

.moneyTableTitle {
  display: flex;
  align-content: center;
}

.mtt {
  flex: 1;
  border: 1px solid #d2d2d2;
  padding: 20px;
  font-weight: 600;
  background-color: #f3f5f8;
}

.mtc {
  flex: 1;
  border: 1px solid #d2d2d2;
  padding: 20px;
}

.list {
  font-size: 20px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #606266;
  padding: 10px 0;
  border-bottom: 1px solid #606266;
  display: flex;
  justify-content: space-between;
}

.list:last-child {
  border-bottom: 0;
}

table {
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  padding: 0;
  margin: 0;
  height: 100%;
}

table td {
  height: auto;
  text-align: left;
  table-layout: fixed;
  padding: 10px 6px;
  font-size: 20px;
  line-height: 100%;
  color: #000000;
  line-height: 40px;
}

table th {
  width: 15%;
  height: auto;
  text-align: left;
  table-layout: fixed;
  padding: 10px 6px;
  font-size: 20px;
  line-height: 100%;
  color: #000000;
  background: #fafafa;
  font-weight: normal;
}

.input-number {
  /* transform: scale(1.25); */
}

.input-number >>> .el-input__inner {
  font-size: 20px;
}
.hetongBox {
  width: 100%;
  height: auto;
  text-align: start;
}
</style>
